module.exports = __webpack_public_path__ + "img/realLeaf2.b87c44b3.png";